export const initialState = { resumeAt: 0, unreadCount: 0 };
